<div class="container-fluid" style="height: 100vh; background-color: white;">
  <!-- Header Section -->
  <div class="row text-light">
    <div class="col-12">
      <app-header></app-header>
    </div>
  </div>

  <!-- Body Section -->
  <div class="row" [ngClass]=" enableNavBar ? '' : 'hide-item'">

</div>
  <div class="row content-height">
    <div class="col-12 px-0" style="background-color: white;">
      <router-outlet style="height: 100%;"></router-outlet>
      <app-redirect></app-redirect>
      <p-toast></p-toast>
    </div>
  </div>
</div>
